module.exports = __webpack_public_path__ + "static/media/nonord-c-6.437fcb0e.mp3";